import { useEffect, useState } from "react";
import { blogData } from "../blogData";
import PostItem from "../components/PostItem";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../contexts/UserContext";
import axios from "axios";
import Loader from "../components/Loader/Loader";

const CategoryPosts = () => {
  const [posts, setPost] = useState(blogData);
  const [loading, setLoading] = useState(false);
  const { category } = useParams();
  useEffect(() => {
    const getCategoryPost = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${BASE_URL}/posts/category/${category}`)
        setPost(data.posts)
      }
      catch (error) {
        setLoading(false);
      } finally {
        setLoading(false)
      }
    }
    getCategoryPost();
  }, [category]);


  return (
    loading ? (
      <Loader />
    ) : (
      <section>
        {posts.length > 0 ? (
          <div className="container posts__container">
            {posts.map((post) => (
              <PostItem key={post._id} post={post} />
            ))}
          </div>
        ) : (
          <div className="container center">
            <h2>No posts yet!</h2>
          </div>
        )}
      </section>
    )
  )
}

export default CategoryPosts


